'use strict'

import Message from "./Message";
import Validator from "./Validator/Validator";
import {Empty, Email, Phone, Length} from "./Validator/Rules";

class Form {

    constructor(){
		var self=this;
		
        this.done_call = null;
        this.fail_call = null;
        this.always_call = null;
		this.sending=false;

        let validators = {
            name: [new Empty()],
            last_name: [new Empty()],
            email: [new Empty(), new Email()],
            phone: [new Empty(), new Phone()],
            date: [new Empty()],
            dealer: [new Empty()],
            city: [new Empty()],
            attach: [new Empty()],
            position: [new Empty()],
            message: [new Empty(), new Length(10, 255)]
        };
        let valid = new Validator();
		
		if($('#phone').length>0){
			$("#phone").mask("(999) 999-9999");
		}
		if($('#date').length>0){
			$('#date')[0].min=new Date().toISOString().split('T')[0];
		}

		$.datepicker.regional['es'] = {
			closeText: 'Cerrar',
			prevText: '< Ant',
			nextText: 'Sig >',
			currentText: 'Hoy',
			monthNames: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
			monthNamesShort: ['Ene','Feb','Mar','Abr', 'May','Jun','Jul','Ago','Sep', 'Oct','Nov','Dic'],
			dayNames: ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'],
			dayNamesShort: ['Dom','Lun','Mar','Mié','Juv','Vie','Sáb'],
			dayNamesMin: ['Do','Lu','Ma','Mi','Ju','Vi','Sá'],
			weekHeader: 'Sm',
			dateFormat: 'dd/mm/yy',
			firstDay: 1,
			isRTL: false,
			showMonthAfterYear: false,
			yearSuffix: ''
		};
		$.datepicker.setDefaults($.datepicker.regional['es']);
		$('input.datepicker').each(function(){
			$(this).datepicker({minDate: new Date()}).attr('readonly','readonly');
		});
		
        $('#testdrive').data().inputs.forEach((input) => {
            valid.add(input, validators[input]);
			switch(input){
				case 'dealer':
					$.getJSON( App.baseUrl + "/ajax/dealers", function( data ) {
						if(data.dealers){
							data.dealers.forEach(dealer => $('#dealer').append($('<option/>').val(dealer.id).text(dealer.titulo).attr('selected', $('#dealer').data().value == dealer.id)));
							$('select').selectric('refresh');
						}
					});
					break;
				case 'model':
					$.getJSON( App.baseUrl + "/ajax/models", function( data ) {
						if(data.models){
							data.models.forEach(model => $('#model').append($('<option/>').val(model.id).text(model.nombre).attr('selected', $('#model').data().value == model.id)));
							$('select').selectric('refresh');
						}
					});
					break;
				case 'position':
					$.getJSON( App.baseUrl + "/ajax/work_with_us", function( data ) {
						if(data.positions){
							data.positions.forEach(position => $('#position').append($('<option/>').val(position.id).text(position.nombre).attr('selected', $('#position').data().value == position.id)));
							$('select').selectric('refresh');
						}
					});
					break;
            }
        });
        $('#testdrive').on('submit', (e) => {
            e.preventDefault();
			
			if(self.sending){
				return false;
			}
			self.sending=true;
			$(e.currentTarget).find('.error').removeClass('error');
			
            if(!valid.validate()) {
                let errors = valid.getErrors();
				for(var i in errors){
					switch(errors[i][0]){
						case 'dealer':
						case 'position':
							$('#'+errors[i][0]).closest('.selectric-wrapper').addClass('error');
							break;
						case 'attach':
							$('#'+errors[i][0]).addClass('error');
							$('#'+errors[i][0]).next().addClass('error');
						default:
							$('#'+errors[i][0]).addClass('error');
							break;
					}
				}
                //console.log('errors:', errors);
                Message.error(errors[0][1][0]);
				self.sending=false;
                return false;
            };

            let s = $.ajax({
				type: 'POST',
				url: $(e.currentTarget).attr('action'),
				data: new FormData($(e.currentTarget)[0]),
				dataType: 'json',
				processData: false,
				contentType: false,
				complete: function(a){
					if(self.done_call){
						self.done_call(JSON.parse(a.responseText));
					}
				},
				error: function(a){
					if(self.fail_call){
						self.fail_call(JSON.parse(a.responseText));
					}
				}
			});
        });
    }

    done(call) {
        this.done_call = call;
        return this;
    }
    
    fail(call) {
        this.fail_call = call;
        return this;
    }
    
    always(call) {
        this.always_call = call;
        return this;
    }

    
}

export default Form;